export const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "method",
    numeric: false,
    disablePadding: false,
    label: "Method",
  },
  {
    id: "url",
    numeric: false,
    disablePadding: false,
    label: "URL",
  },
  {
    id: "body",
    numeric: false,
    disablePadding: false,
    label: "Body",
  },
  {
    id: "headers",
    numeric: false,
    disablePadding: false,
    label: "Headers",
  },
  {
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "Action",
  },
];
